import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wage-status" }
const _hoisted_2 = { class: "month-grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "month-num" }
const _hoisted_5 = { class: "month-indicator" }

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaWageProcessStatus',
  props: {
    selectedYear: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const router = useRouter();

const wageMagamData = ref<any[]>([]);

// 월별 상태 가져오기
const getMonthStatus = (month: number): 'closed' | 'progress' | 'pending' => {
  const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
  
  const monthData = wageMagamData.value.find(
    item => item.wm_job_type === '전체합계' && item.wm_ym === ym
  );
  
  if (!monthData) {
    // 현재 월까지만 '미시작', 그 이후는 '미래'
    const now = new Date();
    if (props.selectedYear > now.getFullYear()) return 'pending';
    if (props.selectedYear === now.getFullYear() && month > now.getMonth() + 1) return 'pending';
    return 'pending';
  }
  
  return monthData.wm_isuse === 'y' ? 'closed' : 'progress';
};

// 월 클릭 핸들러
const handleMonthClick = (month: number) => {
  const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
  router.push(`/pwa/payroll?ym=${ym}`);
};

// 데이터 조회
const fetchData = async () => {
  try {
    const user = store.state.user;
    if (!user?.m_sisul_code) return;

    const response = await axios.get(
      `/api/calc/wage-magam-yearly/${user.m_sisul_code}/${props.selectedYear}`,
      { withCredentials: true }
    );

    if (response.data.success) {
      wageMagamData.value = response.data.data || [];
    }
  } catch (error) {
    console.error('임금 마감 데이터 조회 오류:', error);
  }
};

onMounted(() => {
  fetchData();
});

watch(() => props.selectedYear, () => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
        return _createElementVNode("div", {
          key: month,
          class: _normalizeClass(["month-item", getMonthStatus(month)]),
          onClick: ($event: any) => (handleMonthClick(month))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(month), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "month-label" }, "월", -1)),
          _createElementVNode("div", _hoisted_5, [
            (getMonthStatus(month) === 'closed')
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  size: "12",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-check", -1)
                  ]))]),
                  _: 1
                }))
              : (getMonthStatus(month) === 'progress')
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "12",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-dots-horizontal", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})